enum ReferredToEnum {
    Bizcap = 'BIZCAP',
    DirectCredit = 'DIRECT_CREDIT',
    TLC = 'TLC',
}

export default ReferredToEnum;
